const check = (envKey) => {
  if (window.prod_env_config) {
    return window.prod_env_config[envKey];
  } else {
    return process.env[envKey];
  }
};

export default check;
